import script from "./VersionesView.vue?vue&type=script&lang=ts&setup=true"
export * from "./VersionesView.vue?vue&type=script&lang=ts&setup=true"

import "./VersionesView.vue?vue&type=style&index=0&id=46837cda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46837cda"]])

export default __exports__